import React from 'react';
import { ChevronRight, Microscope } from 'lucide-react';
import { useI18n } from '../hooks/useI18n';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Fixed height to match Varieties section
const CARD_HEIGHT = '280px';
const LIST_HEIGHT = '200px';

export default function TechnologiesList({ technologies = [] }) {
  const { t } = useI18n();

  if (!technologies || technologies.length === 0) return null;

  // Sort technologies by priority (highest first)
  const sortedTechnologies = [...technologies].sort((a, b) => (b.priority || 0) - (a.priority || 0));

  return (
    <div 
      className="flex flex-col bg-[#FBFAF0] md:bg-transparent p-4 md:p-6 lg:p-0 pb-6" 
      style={{ minHeight: CARD_HEIGHT }}
      data-testid="technologies-list"
    >
      <div className="flex-1 flex flex-col">
        {/* Section heading - matches Varieties section */}
        <div className="flex items-center gap-2 mb-4">
          <Microscope className="w-5 h-5 md:w-6 md:h-6 text-[#1B5E20] flex-shrink-0" aria-hidden="true" />
          <h2 className="text-base md:text-lg lg:text-xl font-bold text-[#1B5E20] uppercase leading-tight">
            TECHNOLOGIES FOR COMMERCIALIZATION
          </h2>
        </div>

        {/* Technologies list - matches height with Varieties cards */}
        <div className="bg-white shadow-md rounded-lg overflow-hidden flex-1 flex flex-col" style={{ minHeight: LIST_HEIGHT }}>
          <div className="overflow-y-auto flex-1 custom-scroll" style={{ maxHeight: LIST_HEIGHT }}>
            {sortedTechnologies.map((tech, index) => (
              <a
                key={tech.id || index}
                href="/technologies"
                className="block"
                data-testid={`tech-item-${index}`}
              >
                <div className="border-b border-gray-100 px-4 py-3 hover:bg-green-50 transition flex items-center justify-between group">
                  <span 
                    className="text-sm md:text-base font-medium leading-snug text-gray-800 group-hover:text-[#0E6D2B] pr-2 break-words flex-1"
                  >
                    {tech.name}
                  </span>
                  <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-[#0E6D2B] transition-colors flex-shrink-0 ml-2" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* View More button - simplified */}
      <div className="mt-6">
        <a 
          href="/technologies" 
          className="bg-green-700 text-white px-6 py-3 rounded inline-block font-bold"
        >
          VIEW MORE →
        </a>
      </div>
    </div>
  );
}
